import React, { Component } from "react";
import Table from "../../components/Table/GameTable.jsx";
import { Route, Switch } from "react-router-dom";
import ViewGame from "./ViewGame";
import {
  getAllGames,
  deleteGame,
  closeNotification,
  editGame
} from "../../services/GameServices";
import ViewQuestion from "../Question/ViewQuestion";
import { Collapse, Alert, Row, Col, Grid } from "react-bootstrap";

class ListGames extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formTextField: "",
      formOrderField: "",
      alert: "warning",
      status: "UNKNOWN",
      message: "UNKNOWN",
      isShowing: false,
      games: []
    };
    this.updateGames = this.updateGames.bind(this);
    this.handleGameDelete = this.handleGameDelete.bind(this);
    this.handleGameUpdate = this.handleGameUpdate.bind(this);
  }

  updateGames() {
    getAllGames().then(res => this.setState({ games: res.data.games }));
  }

  componentDidMount() {
    this.updateGames();
  }

  handleGameUpdate(object) {
    const outsideThis = this;
    editGame(object._id, {
      name: object.name,
      broadCastTime: object.broadCastTime
    })
      .then(response => {
        if (response.data.err) {
          console.log(response.data.err);
          outsideThis.setState({
            message:
              response.data.err.name ||
              response.data.err.code ||
              response.data.err,
            isShowing: true,
            status: "ERROR!",
            alert: "danger"
          });
        } else {
          const games = this.state.games.slice();
          let index;
          const game = games.find((game, i) => {
            if (game._id === object._id) {
              index = i;
              return true;
            }
            else{
              //this may be needed to be commented later
              return false;
            }
          });
          games[index] = response.data.game;
          console.log(games);          
          outsideThis.setState({
            message: "Updated game: " + game.name,
            isShowing: true,
            status: "SUCCESS!",
            alert: "success",
            games: games
          });
        }
      })
      .catch(err => {
        outsideThis.setState({
          message: err.name || err.code || err,
          isShowing: true,
          status: "ERROR!",
          alert: "danger"
        });
      })
      .finally(args => {
        closeNotification(this);
      });
  }

  handleGameDelete(obj) {
    const outsideThis = this;
    deleteGame(obj._id)
      .then(response => {
        if (response.data.err) {
          outsideThis.setState({
            message:
              response.data.err.name ||
              response.data.err.code ||
              response.data.err,
            isShowing: true,
            status: "ERROR!",
            alert: "danger"
          });
        } else {
          outsideThis.setState({
            message: "Deleted Game : " + obj.name,
            isShowing: true,
            status: "SUCCESS!",
            alert: "success"
          });
        }
      })
      .catch(err => {
        outsideThis.setState({
          message: err.name || err.code || err,
          isShowing: true,
          status: "ERROR!",
          alert: "danger"
        });
      })
      .finally(args => {
        closeNotification(this);
        outsideThis.updateGames();
      });
  }

  render() {
    return (
      <Switch>
        <Route
          exact
          name="View Games"
          path="/games"
          component={() => (
            <Grid fluid>
              <Row>
                <Col md={12}>
                  <Collapse in={this.state.isShowing}>
                    <Row>
                      <Col xs={6} md={4}>
                        <Alert bsStyle={this.state.alert}>
                          <strong>{this.state.status}</strong>{" "}
                          {this.state.message}
                        </Alert>
                      </Col>
                    </Row>
                  </Collapse>
                  <Table
                    objecttype="quizzes"
                    attributes={["name", "broadCastTime"]}
                    games={this.state.games}
                    onDelete={this.handleGameDelete}
                    onUpdate={this.handleGameUpdate}
                  />
                </Col>
              </Row>
            </Grid>
          )}
        />
        <Route name="View Game" exact path="/games/:id" component={ViewGame} />

        <Route
          name="View Question"
          path="/games/:id/questions/:id2"
          component={ViewQuestion}
        />
      </Switch>
    );
  }
}

export default ListGames;



// WEBPACK FOOTER //
// ./src/views/Game/ListGames.jsx